import PhysicalExerciseManager from './PhysicalExerciseManager';
import TopicCatalog from './TopicCatalog';



import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { formatExamDate } from '../utils/examCountdown';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import './AdminPage.css';

const EMPTY_QUESTION = {
  mock_id: '',
  subject_id: '',
  topic_id: '',
  catalog_topic_id: '',
  year: '',
  institution: '',
  title: '',
  image: null,
  existingImageUrl: '',
  choice_a: '',
  choice_b: '',
  choice_c: '',
  choice_d: '',
  choice_e: '',
  correct: 'A',
  answer: '',
  explication: ''
};

const AdminPage = () => {
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [mocks, setMocks] = useState([]);
  const [selectedMock, setSelectedMock] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [newCourse, setNewCourse] = useState({ name: '', description: '', image_url: '', exam_date: '' });
  const [editingImageCourseId, setEditingImageCourseId] = useState(null);
  const [editingImageValue, setEditingImageValue] = useState('');
  const [editingExamDateCourseId, setEditingExamDateCourseId] = useState(null);
  const [editingExamDateValue, setEditingExamDateValue] = useState('');
  const [newSubject, setNewSubject] = useState({ name: '' });
  const [newMock, setNewMock] = useState({ name: '', description: '', course_id: '', numero_questoes: 0, is_free: false, is_enabled: true });
  const [courseSubjects, setCourseSubjects] = useState([]);
  const [newCourseSubjectId, setNewCourseSubjectId] = useState('');
  const [catalogTopicNames, setCatalogTopicNames] = useState([]);
  const [selectedCatalogTopics, setSelectedCatalogTopics] = useState([]);
  const [selectedCourseSubject, setSelectedCourseSubject] = useState(null);
  const [questionTopicFilter, setQuestionTopicFilter] = useState('');
  const [questionTopics, setQuestionTopics] = useState([]);
  const [freeQuestionsPage, setFreeQuestionsPage] = useState(1);
  const [freeQuestionsTotal, setFreeQuestionsTotal] = useState(0);
  const [freeQuestionsSubjectFilter, setFreeQuestionsSubjectFilter] = useState('');
  const [freeQuestionsTopicFilter, setFreeQuestionsTopicFilter] = useState('');
  const [freeQuestionsTopicOptions, setFreeQuestionsTopicOptions] = useState([]);
  const FREE_QUESTIONS_PAGE_SIZE = 50;
  const [materials, setMaterials] = useState([]);
  const [newMaterial, setNewMaterial] = useState({ nome: '', url: '', is_free: false, is_new: false });
  const [courseMaterials, setCourseMaterials] = useState([]);
  const [newCourseMaterialId, setNewCourseMaterialId] = useState('');
  const [materialsOpen, setMaterialsOpen] = useState(false);
  const [courseMaterialsOpen, setCourseMaterialsOpen] = useState(false);
  const [newQuestion, setNewQuestion] = useState(EMPTY_QUESTION);
  const [editingQuestionId, setEditingQuestionId] = useState(null);
  const [accessDenied, setAccessDenied] = useState(false);
  const [activeTab, setActiveTab] = useState('conteudo');
  const [crmUsers, setCrmUsers] = useState([]);
  const [crmLoading, setCrmLoading] = useState(false);
  const [crmNoteDrafts, setCrmNoteDrafts] = useState({});
  const [crmSavingId, setCrmSavingId] = useState(null);
  const [crmPage, setCrmPage] = useState(1);
  const [crmPageSize, setCrmPageSize] = useState(20);
  const [crmTotal, setCrmTotal] = useState(0);
  const [crmSearchInput, setCrmSearchInput] = useState('');
  const [crmSearch, setCrmSearch] = useState('');
  const [crmPaymentFilter, setCrmPaymentFilter] = useState('all');
  const [crmExpandedUserId, setCrmExpandedUserId] = useState(null);
  const [crmFreeStatsByUser, setCrmFreeStatsByUser] = useState({});
  const [crmFreeStatsLoadingId, setCrmFreeStatsLoadingId] = useState(null);
  const [crmEditingUserId, setCrmEditingUserId] = useState(null);
  const [crmEditDrafts, setCrmEditDrafts] = useState({});
  const [crmProfileSavingId, setCrmProfileSavingId] = useState(null);
  const [crmProfileErrorByUser, setCrmProfileErrorByUser] = useState({});
  const [crmResetStatusByUser, setCrmResetStatusByUser] = useState({});
  const [crmResetSendingId, setCrmResetSendingId] = useState(null);
  const [conversionData, setConversionData] = useState(null);
  const [conversionLoading, setConversionLoading] = useState(false);
  const [conversionDays, setConversionDays] = useState(30);
  const apiUrl = process.env.REACT_APP_API_URL;

  const readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  useEffect(() => {
    fetchCourses();
    fetchSubjects();
    fetchMaterials();
  }, []);

  useEffect(() => {
    if (selectedMock?.id !== null) return;
    fetchFreeQuestions(freeQuestionsPage, freeQuestionsSubjectFilter, freeQuestionsTopicFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMock, freeQuestionsPage, freeQuestionsSubjectFilter, freeQuestionsTopicFilter]);

  useEffect(() => {
    if (selectedMock?.id !== null || !freeQuestionsSubjectFilter) {
      setFreeQuestionsTopicOptions([]);
      return;
    }
    (async () => {
      try {
        const response = await axios.get(`${apiUrl}adm/catalogTopics`, { params: { subjectId: freeQuestionsSubjectFilter } });
        setFreeQuestionsTopicOptions(response.data.topics);
      } catch (error) {
        console.error('Erro ao buscar assuntos para o filtro de questões livres:', error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMock, freeQuestionsSubjectFilter]);

  useEffect(() => {
    if (!newQuestion.subject_id) {
      setQuestionTopics([]);
      return;
    }
    fetchQuestionTopicsBySubject(newQuestion.subject_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newQuestion.subject_id, courseSubjects, selectedMock]);

  useEffect(() => {
    if (activeTab === 'crm') {
      fetchCrmUsers(crmPage, crmPageSize, crmSearch, crmPaymentFilter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, crmPage, crmPageSize, crmSearch, crmPaymentFilter]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCrmPage(1);
      setCrmSearch(crmSearchInput.trim());
    }, 400);
    return () => clearTimeout(timeout);
  }, [crmSearchInput]);

  useEffect(() => {
    if (activeTab === 'conversion') {
      fetchConversionStats(conversionDays);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, conversionDays]);

  const fetchCrmUsers = async (page, pageSize, search, paymentFilter) => {
    setCrmLoading(true);
    try {
      const response = await axios.get(`${apiUrl}adm/crm`, {
        params: { page, pageSize, search: search || undefined, paymentFilter },
      });
      setCrmUsers(response.data.users);
      setCrmTotal(response.data.total);
      setCrmNoteDrafts(
        response.data.users.reduce((acc, user) => {
          acc[user.id] = user.crm_note || '';
          return acc;
        }, {})
      );
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setAccessDenied(true);
      } else {
        console.error('Erro ao buscar dados de CRM:', error);
      }
    } finally {
      setCrmLoading(false);
    }
  };

  const crmTotalPages = Math.max(1, Math.ceil(crmTotal / crmPageSize));

  const fetchConversionStats = async (days) => {
    setConversionLoading(true);
    try {
      const response = await axios.get(`${apiUrl}adm/conversion`, { params: { days } });
      setConversionData(response.data);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setAccessDenied(true);
      } else {
        console.error('Erro ao buscar dados de conversão:', error);
      }
    } finally {
      setConversionLoading(false);
    }
  };

  const conversionSummary = useMemo(() => {
    if (!conversionData) return null;
    const { totalUsers, payingUsers, avgDaysToConvert, engagementRows, signupRows, conversionRows, cohortRows, payingUsersList, guidedOnboardingRows } = conversionData;

    const conversionRate = totalUsers > 0 ? (payingUsers / totalUsers) * 100 : 0;

    const engagementBuckets = { engaged: { total: 0, paid: 0 }, notEngaged: { total: 0, paid: 0 } };
    engagementRows.forEach((row) => {
      const bucket = row.engaged ? engagementBuckets.engaged : engagementBuckets.notEngaged;
      bucket.total += row.count;
      if (row.is_paid) bucket.paid += row.count;
    });

    const dateKey = (value) => (typeof value === 'string' ? value.slice(0, 10) : new Date(value).toISOString().slice(0, 10));
    const dateMap = {};
    signupRows.forEach((row) => {
      const key = dateKey(row.date);
      dateMap[key] = dateMap[key] || { date: key, signups: 0, conversions: 0 };
      dateMap[key].signups = row.signups;
    });
    conversionRows.forEach((row) => {
      const key = dateKey(row.date);
      dateMap[key] = dateMap[key] || { date: key, signups: 0, conversions: 0 };
      dateMap[key].conversions = row.conversions;
    });
    const dailySeries = Object.values(dateMap).sort((a, b) => (a.date < b.date ? -1 : 1));

    const monthlyCohorts = cohortRows.map((row) => ({
      ...row,
      conversionRate: row.signups > 0 ? (row.converted / row.signups) * 100 : 0,
    }));

    const last7 = dailySeries.slice(-7);
    const avgDailySignups = last7.length > 0 ? last7.reduce((sum, d) => sum + d.signups, 0) / last7.length : 0;
    const projectedNewSignups30d = avgDailySignups * 30;
    const projectedNewPayers30d = projectedNewSignups30d * (conversionRate / 100);

    const guidedRow = (guidedOnboardingRows || []).find((row) => row.guidedOnboarding) || null;
    const previousRow = (guidedOnboardingRows || []).find((row) => !row.guidedOnboarding) || null;
    const toCohort = (row) => row && {
      totalUsers: row.totalUsers,
      payingUsers: row.payingUsers,
      conversionRate: row.totalUsers > 0 ? (row.payingUsers / row.totalUsers) * 100 : 0,
      avgDaysToConvert: row.avgDaysToConvert,
    };
    const guidedOnboardingComparison = {
      guided: toCohort(guidedRow),
      previous: toCohort(previousRow),
    };

    return {
      totalUsers,
      payingUsers,
      conversionRate,
      avgDaysToConvert,
      engagementBuckets,
      dailySeries,
      monthlyCohorts,
      avgDailySignups,
      projectedNewSignups30d,
      projectedNewPayers30d,
      payingUsersList: payingUsersList || [],
      guidedOnboardingComparison,
    };
  }, [conversionData]);

  const [payingUsersFilter, setPayingUsersFilter] = useState('');
  const filteredPayingUsers = useMemo(() => {
    if (!conversionSummary) return [];
    const term = payingUsersFilter.trim().toLowerCase();
    if (!term) return conversionSummary.payingUsersList;
    return conversionSummary.payingUsersList.filter((user) =>
      String(user.id).includes(term) ||
      `${user.name} ${user.lastname}`.toLowerCase().includes(term) ||
      (user.email || '').toLowerCase().includes(term)
    );
  }, [conversionSummary, payingUsersFilter]);

  const formatPct = (value) => `${value.toFixed(1)}%`;
  const formatNumber = (value) => Math.round(value).toLocaleString('pt-BR');
  const formatDateShort = (value) => {
    const [, m, d] = value.split('-');
    return `${d}/${m}`;
  };

  const handleSaveCrmNote = async (userId) => {
    setCrmSavingId(userId);
    try {
      await axios.put(`${apiUrl}adm/crm/${userId}`, { note: crmNoteDrafts[userId] || '' });
      setCrmUsers((prev) =>
        prev.map((user) => (user.id === userId ? { ...user, crm_note: crmNoteDrafts[userId] || '' } : user))
      );
    } catch (error) {
      console.error('Erro ao salvar observação:', error);
    } finally {
      setCrmSavingId(null);
    }
  };

  const toggleCrmFreeStats = async (userId) => {
    if (crmExpandedUserId === userId) {
      setCrmExpandedUserId(null);
      return;
    }

    setCrmExpandedUserId(userId);
    if (crmFreeStatsByUser[userId]) return;

    setCrmFreeStatsLoadingId(userId);
    try {
      const response = await axios.get(`${apiUrl}adm/crm/${userId}/free-stats`);
      setCrmFreeStatsByUser((prev) => ({ ...prev, [userId]: response.data.subjects }));
    } catch (error) {
      console.error('Erro ao buscar notas do usuário:', error);
    } finally {
      setCrmFreeStatsLoadingId(null);
    }
  };

  const formatDateTime = (value) => {
    if (!value) return '-';
    return new Date(value).toLocaleString('pt-BR');
  };

  const handleStartEditCrmProfile = (user) => {
    setCrmEditingUserId(user.id);
    setCrmEditDrafts((prev) => ({
      ...prev,
      [user.id]: { name: user.name || '', lastname: user.lastname || '', email: user.email || '' },
    }));
    setCrmProfileErrorByUser((prev) => ({ ...prev, [user.id]: null }));
  };

  const handleCancelEditCrmProfile = (userId) => {
    setCrmEditingUserId(null);
    setCrmProfileErrorByUser((prev) => ({ ...prev, [userId]: null }));
  };

  const handleSaveCrmProfile = async (userId) => {
    const draft = crmEditDrafts[userId];
    if (!draft) return;
    setCrmProfileSavingId(userId);
    setCrmProfileErrorByUser((prev) => ({ ...prev, [userId]: null }));
    try {
      await axios.put(`${apiUrl}adm/users/${userId}`, draft);
      setCrmUsers((prev) =>
        prev.map((user) => (user.id === userId ? { ...user, ...draft } : user))
      );
      setCrmEditingUserId(null);
    } catch (error) {
      const message = error.response?.data?.message || 'Erro ao salvar dados do usuário.';
      setCrmProfileErrorByUser((prev) => ({ ...prev, [userId]: message }));
    } finally {
      setCrmProfileSavingId(null);
    }
  };

  const handleSendResetLink = async (userId, email) => {
    setCrmResetSendingId(userId);
    setCrmResetStatusByUser((prev) => ({ ...prev, [userId]: null }));
    try {
      await axios.post(`${apiUrl}forgot-password`, { email });
      setCrmResetStatusByUser((prev) => ({ ...prev, [userId]: 'Link de redefinição enviado!' }));
    } catch (error) {
      setCrmResetStatusByUser((prev) => ({ ...prev, [userId]: 'Erro ao enviar o link.' }));
    } finally {
      setCrmResetSendingId(null);
    }
  };

  const fetchCourses = async () => {
    try {
      const response = await axios.get(`${apiUrl}adm/courses`);
      setCourses(response.data.courses);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setAccessDenied(true);
      } else {
        console.error('Erro ao buscar cursos:', error);
      }
    }
  };

  const fetchSubjects = async () => {
    try {
      const response = await axios.get(`${apiUrl}adm/subjects`);
      setSubjects(response.data.subjects);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setAccessDenied(true);
      } else {
        console.error('Erro ao buscar matérias:', error);
      }
    }
  };

  const fetchMaterials = async () => {
    try {
      const response = await axios.get(`${apiUrl}adm/materials`);
      setMaterials(response.data.materials);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setAccessDenied(true);
      } else {
        console.error('Erro ao buscar materiais:', error);
      }
    }
  };

  const fetchCourseMaterials = async (courseId) => {
    try {
      const response = await axios.get(`${apiUrl}adm/courseMaterials/${courseId}`);
      setCourseMaterials(response.data.courseMaterials);
    } catch (error) {
      console.error('Erro ao buscar materiais do concurso:', error);
    }
  };

  const fetchMocks = async (courseId) => {
    try {
      const response = await axios.get(`${apiUrl}adm/mocks/${courseId}`);
      setMocks(response.data.mocks);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setAccessDenied(true);
      } else {
        console.error('Erro ao buscar simulados:', error);
      }
    }
  };


  const fetchQuestions = async (mockId) => {
    try {
      const url = mockId ? `${apiUrl}adm/questions/${mockId}` : `${apiUrl}adm/freeQuestions`;
      const response = await axios.get(url);
      setQuestions(response.data.questions);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setAccessDenied(true);
      } else {
        console.error('Erro ao buscar questões:', error);
      }
    }
  };

  // Questões livres podem chegar a milhares de linhas — busca paginada e filtrável
  // no servidor em vez de trazer o banco inteiro de uma vez (fetchQuestions acima).
  const fetchFreeQuestions = async (page, subjectId, topicId) => {
    try {
      const response = await axios.get(`${apiUrl}adm/freeQuestions`, {
        params: {
          page,
          pageSize: FREE_QUESTIONS_PAGE_SIZE,
          subjectId: subjectId || undefined,
          catalogTopicId: topicId || undefined,
        },
      });
      setQuestions(response.data.questions);
      setFreeQuestionsTotal(response.data.total);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setAccessDenied(true);
      } else {
        console.error('Erro ao buscar questões livres:', error);
      }
    }
  };

  const fetchCourseSubjects = async (courseId) => {
    try {
      const response = await axios.get(`${apiUrl}adm/courseSubjects/${courseId}`);
      setCourseSubjects(response.data.courseSubjects);
    } catch (error) {
      console.error('Erro ao buscar matérias do concurso:', error);
    }
  };



  const fetchQuestionTopicsBySubject = async (subjectId) => {
    try {
      const response = await axios.get(`${apiUrl}adm/catalogTopics`, { params: { subjectId } });
      setQuestionTopics(response.data.topics);
    } catch (error) {
      console.error('Erro ao buscar assuntos da questão:', error);
    }
  };

  const handleCreateCourse = async () => {
    try {
      await axios.post(`${apiUrl}adm/courses`, newCourse);
      setNewCourse({ name: '', description: '', image_url: '', exam_date: '' });
      fetchCourses();
    } catch (error) {
      console.error('Erro ao criar curso:', error);
    }
  };

  const startEditingCourseImage = (course, event) => {
    event.stopPropagation();
    setEditingImageCourseId(course.id);
    setEditingImageValue(course.image_url || '');
  };

  const handleSaveCourseImage = async (courseId) => {
    try {
      await axios.put(`${apiUrl}adm/courses/${courseId}/image`, { image_url: editingImageValue });
      setEditingImageCourseId(null);
      fetchCourses();
    } catch (error) {
      console.error('Erro ao salvar imagem do curso:', error);
    }
  };

  const startEditingCourseExamDate = (course, event) => {
    event.stopPropagation();
    setEditingExamDateCourseId(course.id);
    setEditingExamDateValue(course.exam_date || '');
  };

  const handleSaveCourseExamDate = async (courseId) => {
    try {
      await axios.put(`${apiUrl}adm/courses/${courseId}/exam-date`, { exam_date: editingExamDateValue });
      setEditingExamDateCourseId(null);
      fetchCourses();
    } catch (error) {
      console.error('Erro ao salvar data da prova do curso:', error);
    }
  };

  const handleCreateSubject = async () => {
    try {
      await axios.post(`${apiUrl}adm/subjects`, newSubject);
      setNewSubject({ name: '' });
      fetchSubjects();
    } catch (error) {
      console.error('Erro ao criar matéria:', error);
    }
  };

  const handleCreateMock = async () => {
    try {
      await axios.post(`${apiUrl}adm/mocks`, newMock);
      setNewMock({ name: '', description: '', course_id: '', numero_questoes: 0, is_free: false, is_enabled: true });
      if (selectedCourse) fetchMocks(selectedCourse.id);
    } catch (error) {
      console.error('Erro ao criar simulado:', error);
    }
  };

  const handleToggleMockEnabled = async (mock, isEnabled) => {
    try {
      await axios.put(`${apiUrl}adm/mocks/${mock.id}/enabled`, { is_enabled: isEnabled });
      setMocks(prev => prev.map(m => m.id === mock.id ? { ...m, is_enabled: isEnabled } : m));
    } catch (error) {
      console.error('Erro ao atualizar simulado:', error);
    }
  };





  const fetchTopicNamesCatalog = async (subjectId) => {
    if (!subjectId) return [];
    try {
      const response = await axios.get(`${apiUrl}adm/subjects/${subjectId}/topicNames`);
      return response.data.topicNames;
    } catch (error) {
      console.error('Erro ao buscar tópicos já cadastrados da matéria:', error);
      return [];
    }
  };

  const handleSelectNewCourseSubject = async (subjectId) => {
    setNewCourseSubjectId(subjectId);
    setSelectedCatalogTopics([]);
    setCatalogTopicNames(await fetchTopicNamesCatalog(subjectId));
  };

  const toggleCatalogTopic = (topicName) => {
    setSelectedCatalogTopics((prev) =>
      prev.includes(topicName)
        ? prev.filter((name) => name !== topicName)
        : [...prev, topicName]
    );
  };


  const handleLinkCourseSubject = async () => {
    if (!selectedCourse || !newCourseSubjectId) {
      alert('Selecione uma matéria antes de vincular ao concurso.');
      return;
    }
    try {
      await axios.post(`${apiUrl}adm/courseSubjects`, {
        course_id: selectedCourse.id,
        subject_id: newCourseSubjectId,
        topic_names: selectedCatalogTopics
      });
      setNewCourseSubjectId('');
      setCatalogTopicNames([]);
      setSelectedCatalogTopics([]);
      fetchCourseSubjects(selectedCourse.id);
    } catch (error) {
      console.error('Erro ao vincular matéria ao concurso:', error);
    }
  };

  const handleUnlinkCourseSubject = async (courseSubjectId) => {
    try {
      await axios.delete(`${apiUrl}adm/courseSubjects/${courseSubjectId}`);
      if (selectedCourseSubject?.course_subject_id === courseSubjectId) {
        setSelectedCourseSubject(null);
      }
      if (selectedCourse) fetchCourseSubjects(selectedCourse.id);
    } catch (error) {
      console.error('Erro ao desvincular matéria do concurso:', error);
    }
  };

  const selectCourseSubject = async (courseSubject) => {
    setSelectedCourseSubject(courseSubject);
  };







  const handleSyncCourseQuestions = async () => {
    if (!selectedCourse) return;
    try {
      const { data } = await axios.post(`${apiUrl}adm/courses/${selectedCourse.id}/sync-questions`);
      // "0" aqui não é erro: o vínculo em course_question é por (curso, questão), não por
      // (curso, matéria, questão) — se outra matéria equivalente já tiver sincronizado as
      // mesmas questões antes (ex.: duas matérias apontando pra mesma "canônica"), não sobra
      // nada novo pra inserir. Deixa isso explícito pra não parecer que a sincronização falhou.
      if (data.linked === 0) {
        alert('Nenhuma questão nova para vincular — o conteúdo já estava sincronizado com este curso.');
      } else {
        alert(`${data.linked} questão(ões) nova(s) vinculada(s) ao curso.`);
      }
    } catch (error) {
      console.error('Erro ao sincronizar questões:', error);
      alert('Erro ao sincronizar questões');
    }
  };

  const handleCreateMaterial = async () => {
    if (!newMaterial.nome.trim() || !newMaterial.url.trim()) {
      alert('Preencha o nome e a URL do material.');
      return;
    }
    try {
      await axios.post(`${apiUrl}adm/materials`, newMaterial);
      setNewMaterial({ nome: '', url: '', is_free: false, is_new: false });
      fetchMaterials();
    } catch (error) {
      console.error('Erro ao criar material:', error);
    }
  };

  const handleLinkCourseMaterial = async () => {
    if (!selectedCourse || !newCourseMaterialId) {
      alert('Selecione um material antes de vincular ao concurso.');
      return;
    }
    try {
      await axios.post(`${apiUrl}adm/courseMaterials`, {
        course_id: selectedCourse.id,
        material_id: newCourseMaterialId
      });
      setNewCourseMaterialId('');
      fetchCourseMaterials(selectedCourse.id);
    } catch (error) {
      console.error('Erro ao vincular material ao concurso:', error);
    }
  };

  const handleUnlinkCourseMaterial = async (courseMaterialId) => {
    try {
      await axios.delete(`${apiUrl}adm/courseMaterials/${courseMaterialId}`);
      if (selectedCourse) fetchCourseMaterials(selectedCourse.id);
    } catch (error) {
      console.error('Erro ao desvincular material do concurso:', error);
    }
  };

  const handleCreateQuestion = async () => {
    try {
      const questionData = {
        mock_id: newQuestion.mock_id,
        subject_id: newQuestion.subject_id,
        topic_id: null,
        catalog_topic_id: newQuestion.catalog_topic_id || null,
        year: newQuestion.year || null,
        institution: newQuestion.institution || null,
        title: newQuestion.title,
        choice_a: newQuestion.choice_a,
        choice_b: newQuestion.choice_b,
        choice_c: newQuestion.choice_c,
        choice_d: newQuestion.choice_d,
        choice_e: newQuestion.choice_e,
        correct: newQuestion.correct,
        answer: newQuestion.answer,
        explication: newQuestion.explication,
      };

      if (newQuestion.image) {
        questionData.image_url = await readFileAsDataURL(newQuestion.image);
      }

      await axios.post(`${apiUrl}adm/questions`, questionData);
      setNewQuestion(EMPTY_QUESTION);
      if (selectedMock?.id === null) {
        fetchFreeQuestions(freeQuestionsPage, freeQuestionsSubjectFilter, freeQuestionsTopicFilter);
      } else if (selectedMock) {
        fetchQuestions(selectedMock.id);
      }
    } catch (error) {
      console.error('Erro ao criar questão:', error);
      alert('Erro ao criar questão. Nada foi salvo — confira os campos e tente novamente.');
    }
  };

  const handleEditQuestion = (question) => {
    setEditingQuestionId(question.id);
    setNewQuestion({
      mock_id: question.mock_id || '',
      subject_id: question.subject_id || '',
      topic_id: question.topic_id || '',
      catalog_topic_id: question.catalog_topic_id || '',
      year: question.year || '',
      institution: question.institution || '',
      title: question.title || '',
      image: null,
      existingImageUrl: question.image_url || '',
      choice_a: question.choice_a || '',
      choice_b: question.choice_b || '',
      choice_c: question.choice_c || '',
      choice_d: question.choice_d || '',
      choice_e: question.choice_e || '',
      correct: question.correct || 'A',
      answer: question.answer || '',
      explication: question.explication || '',
    });
  };

  const handleCancelEditQuestion = () => {
    setEditingQuestionId(null);
    setNewQuestion(EMPTY_QUESTION);
  };

  const handleUpdateQuestion = async () => {
    try {
      const questionData = {
        mock_id: newQuestion.mock_id,
        subject_id: newQuestion.subject_id,
        topic_id: null,
        catalog_topic_id: newQuestion.catalog_topic_id || null,
        year: newQuestion.year || null,
        institution: newQuestion.institution || null,
        title: newQuestion.title,
        choice_a: newQuestion.choice_a,
        choice_b: newQuestion.choice_b,
        choice_c: newQuestion.choice_c,
        choice_d: newQuestion.choice_d,
        choice_e: newQuestion.choice_e,
        correct: newQuestion.correct,
        answer: newQuestion.answer,
        explication: newQuestion.explication,
        image_url: newQuestion.existingImageUrl || null,
      };

      if (newQuestion.image) {
        questionData.image_url = await readFileAsDataURL(newQuestion.image);
      }

      await axios.put(`${apiUrl}adm/questions/${editingQuestionId}`, questionData);
      setEditingQuestionId(null);
      setNewQuestion(EMPTY_QUESTION);
      if (selectedMock?.id === null) {
        fetchFreeQuestions(freeQuestionsPage, freeQuestionsSubjectFilter, freeQuestionsTopicFilter);
      } else if (selectedMock) {
        fetchQuestions(selectedMock.id);
      }
    } catch (error) {
      console.error('Erro ao atualizar questão:', error);
      alert('Erro ao atualizar questão. Nada foi salvo — confira os campos e tente novamente.');
    }
  };

  const handleDeleteQuestion = async (questionId) => {
    if (!window.confirm('Excluir esta questão? As respostas dos usuários para ela também serão apagadas. Essa ação não pode ser desfeita.')) {
      return;
    }
    try {
      await axios.delete(`${apiUrl}adm/questions/${questionId}`);
      if (editingQuestionId === questionId) {
        setEditingQuestionId(null);
        setNewQuestion(EMPTY_QUESTION);
      }
      if (selectedMock?.id === null) {
        fetchFreeQuestions(freeQuestionsPage, freeQuestionsSubjectFilter, freeQuestionsTopicFilter);
      } else if (selectedMock) {
        fetchQuestions(selectedMock.id);
      }
    } catch (error) {
      console.error('Erro ao excluir questão:', error);
      alert('Erro ao excluir questão.');
    }
  };

  const selectCourse = (course) => {
    setSelectedCourse(course);
    setSelectedMock(null);
    setMocks([]);
    setQuestions([]);
    setSelectedCourseSubject(null);
    setEditingQuestionId(null);
    setNewQuestion(EMPTY_QUESTION);
    fetchMocks(course.id);
    fetchCourseSubjects(course.id);
    fetchCourseMaterials(course.id);
  };

  const selectMock = (mock) => {
    setSelectedMock(mock);
    setQuestions([]);
    setEditingQuestionId(null);
    setNewQuestion(EMPTY_QUESTION);
    fetchQuestions(mock.id);
  };

  // Questões livres não pertencem a nenhum simulado (mock_id NULL) — reaproveita o
  // mesmo formulário/lista de "selectedMock", com id null como sentinela.
  const selectFreeQuestions = () => {
    setSelectedCourse(null);
    setCourseSubjects([]);
    setMocks([]);
    setSelectedMock({ id: null, name: 'Questões Livres' });
    setQuestions([]);
    setEditingQuestionId(null);
    setNewQuestion(EMPTY_QUESTION);
    setFreeQuestionsPage(1);
    setFreeQuestionsSubjectFilter('');
    setFreeQuestionsTopicFilter('');
    setFreeQuestionsTopicOptions([]);
  };

  if (accessDenied) {
    return (
      <div className="admin-container">
        <h1>Acesso Negado</h1>
        <p>Apenas administradores podem acessar esta página.</p>
      </div>
    );
  }

  return (
    <div className={`admin-container${activeTab === 'crm' || activeTab === 'conversion' ? ' wide' : ''}`}>
      <h1>Página de Administração</h1>

      <div className="admin-tabs">
        <button
          className={activeTab === 'conteudo' ? 'active' : ''}
          onClick={() => setActiveTab('conteudo')}
        >
          Conteúdo
        </button>
        <button
          className={activeTab === 'crm' ? 'active' : ''}
          onClick={() => setActiveTab('crm')}
        >
          CRM
        </button>
        <button
          className={activeTab === 'conversion' ? 'active' : ''}
          onClick={() => setActiveTab('conversion')}
        >
          Conversão
        </button>
      </div>

      {activeTab === 'crm' && (
        <div className="section crm-section">
          <div className="crm-header">
            <h2>CRM de Usuários</h2>
            <div className="crm-header-controls">
              <input
                type="text"
                className="crm-search-input"
                placeholder="Buscar por nome, telefone ou e-mail"
                value={crmSearchInput}
                onChange={(e) => setCrmSearchInput(e.target.value)}
              />
              <label className="crm-page-size">
                Pagamento:
                <select
                  value={crmPaymentFilter}
                  onChange={(e) => {
                    setCrmPaymentFilter(e.target.value);
                    setCrmPage(1);
                  }}
                >
                  <option value="all">Todos</option>
                  <option value="paid">Pagantes</option>
                  <option value="unpaid">Não pagantes</option>
                </select>
              </label>
              <label className="crm-page-size">
                Por página:
                <select
                  value={crmPageSize}
                  onChange={(e) => {
                    setCrmPageSize(Number(e.target.value));
                    setCrmPage(1);
                  }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </label>
            </div>
          </div>
          {crmLoading && <p>Carregando...</p>}
          {!crmLoading && (
            <>
              <div className="crm-table-wrapper">
                <table className="crm-table">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Contato</th>
                      <th>Pago</th>
                      <th>Cadastro</th>
                      <th>Últ. Atividade</th>
                      <th>Engajamento</th>
                      <th>Observação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {crmUsers.length === 0 && (
                      <tr>
                        <td colSpan={7} className="crm-muted">Nenhum usuário encontrado.</td>
                      </tr>
                    )}
                    {crmUsers.map((user) => {
                      const isExpanded = crmExpandedUserId === user.id;
                      const freeStats = crmFreeStatsByUser[user.id];
                      const isEditingProfile = crmEditingUserId === user.id;
                      const draft = crmEditDrafts[user.id] || { name: '', lastname: '', email: '' };
                      return (
                        <React.Fragment key={user.id}>
                          <tr>
                            {isEditingProfile ? (
                              <>
                                <td className="crm-cell-name crm-cell-editing">
                                  <input
                                    type="text"
                                    className="crm-edit-input"
                                    placeholder="Nome"
                                    value={draft.name}
                                    onChange={(e) =>
                                      setCrmEditDrafts((prev) => ({ ...prev, [user.id]: { ...draft, name: e.target.value } }))
                                    }
                                  />
                                  <input
                                    type="text"
                                    className="crm-edit-input"
                                    placeholder="Sobrenome"
                                    value={draft.lastname}
                                    onChange={(e) =>
                                      setCrmEditDrafts((prev) => ({ ...prev, [user.id]: { ...draft, lastname: e.target.value } }))
                                    }
                                  />
                                </td>
                                <td className="crm-cell-contact crm-cell-editing">
                                  <input
                                    type="email"
                                    className="crm-edit-input"
                                    placeholder="E-mail"
                                    value={draft.email}
                                    onChange={(e) =>
                                      setCrmEditDrafts((prev) => ({ ...prev, [user.id]: { ...draft, email: e.target.value } }))
                                    }
                                  />
                                  <span className="crm-phone">{user.phone || '-'}</span>
                                  {crmProfileErrorByUser[user.id] && (
                                    <span className="crm-edit-error">{crmProfileErrorByUser[user.id]}</span>
                                  )}
                                  <div className="crm-edit-actions">
                                    <button
                                      type="button"
                                      className="crm-save-btn"
                                      onClick={() => handleSaveCrmProfile(user.id)}
                                      disabled={crmProfileSavingId === user.id}
                                    >
                                      {crmProfileSavingId === user.id ? '...' : 'Salvar'}
                                    </button>
                                    <button
                                      type="button"
                                      className="crm-cancel-btn"
                                      onClick={() => handleCancelEditCrmProfile(user.id)}
                                    >
                                      Cancelar
                                    </button>
                                  </div>
                                  <button
                                    type="button"
                                    className="crm-reset-link-btn"
                                    onClick={() => handleSendResetLink(user.id, user.email)}
                                    disabled={crmResetSendingId === user.id}
                                  >
                                    {crmResetSendingId === user.id ? 'Enviando...' : 'Enviar link de redefinição de senha'}
                                  </button>
                                  {crmResetStatusByUser[user.id] && (
                                    <span className="crm-reset-status">{crmResetStatusByUser[user.id]}</span>
                                  )}
                                </td>
                              </>
                            ) : (
                              <>
                                <td className="crm-cell-name" title={`${user.name} ${user.lastname}`}>
                                  {user.name} {user.lastname}
                                  <button
                                    type="button"
                                    className="crm-edit-toggle"
                                    onClick={() => handleStartEditCrmProfile(user)}
                                  >
                                    Editar
                                  </button>
                                </td>
                                <td className="crm-cell-contact">
                                  <span className="crm-email" title={user.email}>{user.email}</span>
                                  <span className="crm-phone">{user.phone || '-'}</span>
                                </td>
                              </>
                            )}
                            <td>
                              <span className={`crm-badge ${user.is_paid ? 'crm-badge-yes' : 'crm-badge-no'}`}>
                                {user.is_paid ? 'Pago' : 'Não'}
                              </span>
                            </td>
                            <td className="crm-cell-date">{formatDateTime(user.created_at)}</td>
                            <td className="crm-cell-date">{formatDateTime(user.last_activity)}</td>
                            <td>
                              {user.is_paid ? (
                                <span className="crm-muted">-</span>
                              ) : (
                                <div className="crm-engagement">
                                  <span className={`crm-badge crm-badge-sm ${user.did_free_mock ? 'crm-badge-yes' : 'crm-badge-no'}`}>
                                    Simulado {user.did_free_mock ? '✓' : '✗'}
                                  </span>
                                  <span className={`crm-badge crm-badge-sm ${user.answered_free_question ? 'crm-badge-yes' : 'crm-badge-no'}`}>
                                    Questão {user.answered_free_question ? '✓' : '✗'}
                                  </span>
                                  <button
                                    type="button"
                                    className="crm-free-stats-toggle"
                                    onClick={() => toggleCrmFreeStats(user.id)}
                                  >
                                    {isExpanded ? 'Ocultar notas' : 'Ver notas'}
                                  </button>
                                </div>
                              )}
                            </td>
                            <td className="crm-cell-note">
                              <div className="crm-note-row">
                                <textarea
                                  className="crm-note-input"
                                  value={crmNoteDrafts[user.id] ?? ''}
                                  onChange={(e) =>
                                    setCrmNoteDrafts({ ...crmNoteDrafts, [user.id]: e.target.value })
                                  }
                                  placeholder="Bom lead?"
                                />
                                <button
                                  className="crm-save-btn"
                                  onClick={() => handleSaveCrmNote(user.id)}
                                  disabled={crmSavingId === user.id || (crmNoteDrafts[user.id] || '') === (user.crm_note || '')}
                                >
                                  {crmSavingId === user.id ? '...' : 'Salvar'}
                                </button>
                              </div>
                            </td>
                          </tr>
                          {isExpanded && (
                            <tr className="crm-free-stats-row">
                              <td colSpan={7}>
                                {crmFreeStatsLoadingId === user.id ? (
                                  <p className="crm-muted">Carregando notas...</p>
                                ) : !freeStats || freeStats.length === 0 ? (
                                  <p className="crm-muted">
                                    Esse usuário ainda não respondeu nenhuma questão do simulado gratuito ou das questões livres.
                                  </p>
                                ) : (
                                  <div className="crm-free-stats">
                                    {freeStats.map((subject) => (
                                      <div key={subject.subjectName} className="crm-free-stats-item">
                                        <div className="crm-free-stats-header">
                                          <span>{subject.subjectName}</span>
                                          <strong>{subject.percentage}% de acerto</strong>
                                        </div>
                                        <div className="crm-free-stats-bar-track">
                                          <div
                                            className="crm-free-stats-bar-fill"
                                            style={{ width: `${Math.min(subject.percentage, 100)}%` }}
                                          />
                                        </div>
                                        <small>
                                          {subject.correct} acertos / {subject.incorrect} erros ({subject.total} respondidas)
                                        </small>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="crm-pagination">
                <button onClick={() => setCrmPage(1)} disabled={crmPage <= 1}>«</button>
                <button onClick={() => setCrmPage((p) => Math.max(1, p - 1))} disabled={crmPage <= 1}>‹</button>
                <span>Página {crmPage} de {crmTotalPages} ({crmTotal} usuários)</span>
                <button onClick={() => setCrmPage((p) => Math.min(crmTotalPages, p + 1))} disabled={crmPage >= crmTotalPages}>›</button>
                <button onClick={() => setCrmPage(crmTotalPages)} disabled={crmPage >= crmTotalPages}>»</button>
              </div>
            </>
          )}
        </div>
      )}

      {activeTab === 'conversion' && (
        <div className="section conversion-section">
          <div className="conversion-header">
            <h2>Conversão</h2>
            <label className="crm-page-size">
              Período:
              <select
                value={conversionDays}
                onChange={(e) => setConversionDays(Number(e.target.value))}
              >
                <option value={7}>Últimos 7 dias</option>
                <option value={30}>Últimos 30 dias</option>
                <option value={90}>Últimos 90 dias</option>
                <option value={180}>Últimos 180 dias</option>
              </select>
            </label>
          </div>

          {conversionLoading && <p>Carregando...</p>}

          {!conversionLoading && conversionSummary && (
            <>
              <div className="conversion-kpis">
                <div className="conversion-kpi">
                  <span className="conversion-kpi-label">Usuários cadastrados</span>
                  <span className="conversion-kpi-value">{formatNumber(conversionSummary.totalUsers)}</span>
                </div>
                <div className="conversion-kpi">
                  <span className="conversion-kpi-label">Usuários pagantes</span>
                  <span className="conversion-kpi-value">{formatNumber(conversionSummary.payingUsers)}</span>
                </div>
                <div className="conversion-kpi conversion-kpi-highlight">
                  <span className="conversion-kpi-label">Taxa de conversão</span>
                  <span className="conversion-kpi-value">{formatPct(conversionSummary.conversionRate)}</span>
                </div>
                <div className="conversion-kpi">
                  <span className="conversion-kpi-label">Tempo médio até converter</span>
                  <span className="conversion-kpi-value">
                    {conversionSummary.avgDaysToConvert !== null ? `${conversionSummary.avgDaysToConvert.toFixed(1)} dias` : '-'}
                  </span>
                </div>
              </div>

              <div className="conversion-block">
                <h3>Cadastros vs. conversões por dia</h3>
                <ResponsiveContainer width="100%" height={280}>
                  <LineChart data={conversionSummary.dailySeries} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" tickFormatter={formatDateShort} fontSize={12} />
                    <YAxis allowDecimals={false} fontSize={12} />
                    <Tooltip labelFormatter={formatDateShort} />
                    <Legend />
                    <Line type="monotone" dataKey="signups" name="Cadastros" stroke="#4CAF50" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="conversions" name="Conversões" stroke="#E8802F" strokeWidth={2} dot={false} />
                  </LineChart>
                </ResponsiveContainer>
              </div>

              <div className="conversion-block">
                <h3>Conversão por mês de cadastro (coorte)</h3>
                <ResponsiveContainer width="100%" height={280}>
                  <BarChart data={conversionSummary.monthlyCohorts} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" fontSize={12} />
                    <YAxis allowDecimals={false} fontSize={12} />
                    <Tooltip formatter={(value, name) => (name === 'conversionRate' ? formatPct(value) : value)} />
                    <Legend />
                    <Bar dataKey="signups" name="Cadastros" fill="#90caf9" />
                    <Bar dataKey="converted" name="Convertidos" fill="#E8802F" />
                  </BarChart>
                </ResponsiveContainer>
              </div>

              <div className="conversion-block">
                <h3>Conversão por engajamento (usuários não pagantes)</h3>
                <div className="conversion-engagement-grid">
                  <div className="conversion-engagement-card">
                    <span className="conversion-engagement-title">Engajados (fizeram simulado ou responderam questão grátis)</span>
                    <span className="conversion-engagement-value">
                      {formatPct(
                        conversionSummary.engagementBuckets.engaged.total > 0
                          ? (conversionSummary.engagementBuckets.engaged.paid / conversionSummary.engagementBuckets.engaged.total) * 100
                          : 0
                      )}
                    </span>
                    <span className="conversion-engagement-sub">
                      {formatNumber(conversionSummary.engagementBuckets.engaged.paid)} de {formatNumber(conversionSummary.engagementBuckets.engaged.total)} converteram
                    </span>
                  </div>
                  <div className="conversion-engagement-card">
                    <span className="conversion-engagement-title">Não engajados</span>
                    <span className="conversion-engagement-value">
                      {formatPct(
                        conversionSummary.engagementBuckets.notEngaged.total > 0
                          ? (conversionSummary.engagementBuckets.notEngaged.paid / conversionSummary.engagementBuckets.notEngaged.total) * 100
                          : 0
                      )}
                    </span>
                    <span className="conversion-engagement-sub">
                      {formatNumber(conversionSummary.engagementBuckets.notEngaged.paid)} de {formatNumber(conversionSummary.engagementBuckets.notEngaged.total)} converteram
                    </span>
                  </div>
                </div>
              </div>

              {conversionSummary.guidedOnboardingComparison.guided && (
                <div className="conversion-block">
                  <h3>Conversão: funil guiado vs. base anterior</h3>
                  <p className="conversion-note">
                    Cadastrados depois do funil guiado (plano de estudos → 10 questões → tela de venda)
                    comparados com a base anterior (cadastros de antes do lançamento, sem o funil).
                  </p>
                  <div className="conversion-engagement-grid">
                    <div className="conversion-engagement-card">
                      <span className="conversion-engagement-title">Funil guiado (novos cadastros)</span>
                      <span className="conversion-engagement-value">
                        {formatPct(conversionSummary.guidedOnboardingComparison.guided.conversionRate)}
                      </span>
                      <span className="conversion-engagement-sub">
                        {formatNumber(conversionSummary.guidedOnboardingComparison.guided.payingUsers)} de{' '}
                        {formatNumber(conversionSummary.guidedOnboardingComparison.guided.totalUsers)} converteram
                      </span>
                    </div>
                    <div className="conversion-engagement-card">
                      <span className="conversion-engagement-title">Base anterior (sem funil)</span>
                      <span className="conversion-engagement-value">
                        {conversionSummary.guidedOnboardingComparison.previous
                          ? formatPct(conversionSummary.guidedOnboardingComparison.previous.conversionRate)
                          : '-'}
                      </span>
                      <span className="conversion-engagement-sub">
                        {conversionSummary.guidedOnboardingComparison.previous
                          ? `${formatNumber(conversionSummary.guidedOnboardingComparison.previous.payingUsers)} de ${formatNumber(conversionSummary.guidedOnboardingComparison.previous.totalUsers)} converteram`
                          : 'Sem usuários nessa base'}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              <div className="conversion-block">
                <h3>Estimativas (baseadas na média dos últimos 7 dias)</h3>
                <div className="conversion-kpis">
                  <div className="conversion-kpi">
                    <span className="conversion-kpi-label">Cadastros/dia (média)</span>
                    <span className="conversion-kpi-value">{conversionSummary.avgDailySignups.toFixed(1)}</span>
                  </div>
                  <div className="conversion-kpi">
                    <span className="conversion-kpi-label">Cadastros estimados (30 dias)</span>
                    <span className="conversion-kpi-value">{formatNumber(conversionSummary.projectedNewSignups30d)}</span>
                  </div>
                  <div className="conversion-kpi conversion-kpi-highlight">
                    <span className="conversion-kpi-label">Novos pagantes estimados (30 dias)</span>
                    <span className="conversion-kpi-value">{formatNumber(conversionSummary.projectedNewPayers30d)}</span>
                  </div>
                </div>
                <p className="conversion-note">
                  Estimativa simples: projeta o ritmo de cadastros dos últimos 7 dias para os próximos 30 dias e aplica a taxa de conversão atual. Não considera sazonalidade nem campanhas pontuais.
                </p>
              </div>

              <div className="conversion-block">
                <div className="conversion-list-header">
                  <h3>Usuários pagantes ({conversionSummary.payingUsersList.length})</h3>
                  <input
                    type="text"
                    className="conversion-list-filter"
                    placeholder="Filtrar por id, nome ou e-mail"
                    value={payingUsersFilter}
                    onChange={(e) => setPayingUsersFilter(e.target.value)}
                  />
                </div>
                <div className="crm-table-wrapper">
                  <table className="crm-table conversion-users-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th>Plano</th>
                        <th>Cadastro</th>
                        <th>Pagou em</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredPayingUsers.map((user) => (
                        <tr key={user.id}>
                          <td>{user.id}</td>
                          <td>{user.name} {user.lastname}</td>
                          <td title={user.email}>{user.email}</td>
                          <td>{user.plan_name || '-'}</td>
                          <td className="crm-cell-date">{formatDateTime(user.created_at)}</td>
                          <td className="crm-cell-date">{formatDateTime(user.paid_at)}</td>
                        </tr>
                      ))}
                      {filteredPayingUsers.length === 0 && (
                        <tr>
                          <td colSpan={6} className="crm-muted">Nenhum usuário encontrado.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="conversion-block conversion-suggestions">
                <h3>Outros dados úteis para analisar conversão</h3>
                <ul>
                  <li><strong>Origem do tráfego (UTM/campanha):</strong> saber de onde vêm os cadastros que mais convertem para priorizar canais de aquisição.</li>
                  <li><strong>Plano/valor pago e forma de pagamento:</strong> hoje só sabemos "pago ou não" — ter o valor permitiria calcular receita (MRR) e ticket médio.</li>
                  <li><strong>Cancelamentos/reembolsos:</strong> não há esse dado hoje; sem ele a "taxa de conversão" não reflete churn nem receita líquida.</li>
                  <li><strong>Funil de checkout:</strong> quantos usuários visitaram a página de pagamento vs. quantos de fato compraram (hoje só vemos quem entrou no site e quem pagou).</li>
                  <li><strong>Concurso/curso de interesse:</strong> cruzar conversão por curso ajuda a saber quais concursos convertem melhor.</li>
                  <li><strong>Dispositivo/canal de cadastro:</strong> mobile vs. desktop, para identificar atrito em algum fluxo.</li>
                </ul>
              </div>
            </>
          )}
        </div>
      )}

      {activeTab === 'conteudo' && (
      <div className="admin-content-layout">
        <aside className="admin-sidebar">
          <div className="admin-card">
            <h3>Novo concurso</h3>
            <input
              type="text"
              placeholder="Nome do concurso"
              value={newCourse.name}
              onChange={(e) => setNewCourse({ ...newCourse, name: e.target.value })}
            />
            <textarea
              placeholder="Descrição"
              value={newCourse.description}
              onChange={(e) => setNewCourse({ ...newCourse, description: e.target.value })}
            />
            <input
              type="text"
              placeholder="URL da imagem/brasão (opcional)"
              value={newCourse.image_url}
              onChange={(e) => setNewCourse({ ...newCourse, image_url: e.target.value })}
            />
            <label>
              Data da prova (opcional)
              <input
                type="date"
                value={newCourse.exam_date}
                onChange={(e) => setNewCourse({ ...newCourse, exam_date: e.target.value })}
              />
            </label>
            <button className="admin-btn-primary" onClick={handleCreateCourse}>Criar Concurso</button>
          </div>

          <div className="admin-card">
            <h3>Concursos</h3>
            <ul className="admin-nav-list">
              {courses.map(course => (
                <li key={course.id} onClick={() => selectCourse(course)} className={selectedCourse?.id === course.id ? 'selected' : ''}>
                  {course.name}
                  {editingImageCourseId === course.id ? (
                    <span className="admin-inline-form" onClick={(e) => e.stopPropagation()}>
                      <input
                        type="text"
                        placeholder="URL da imagem/brasão"
                        value={editingImageValue}
                        onChange={(e) => setEditingImageValue(e.target.value)}
                      />
                      <button className="admin-btn-primary" onClick={() => handleSaveCourseImage(course.id)}>Salvar</button>
                      <button className="admin-btn-secondary" onClick={() => setEditingImageCourseId(null)}>Cancelar</button>
                    </span>
                  ) : (
                    <button
                      className="admin-nav-list-action"
                      onClick={(e) => startEditingCourseImage(course, e)}
                    >
                      {course.image_url ? 'Trocar imagem' : 'Definir imagem'}
                    </button>
                  )}
                  {editingExamDateCourseId === course.id ? (
                    <span className="admin-inline-form" onClick={(e) => e.stopPropagation()}>
                      <input
                        type="date"
                        value={editingExamDateValue}
                        onChange={(e) => setEditingExamDateValue(e.target.value)}
                      />
                      <button className="admin-btn-primary" onClick={() => handleSaveCourseExamDate(course.id)}>Salvar</button>
                      <button className="admin-btn-secondary" onClick={() => setEditingExamDateCourseId(null)}>Cancelar</button>
                    </span>
                  ) : (
                    <button
                      className="admin-nav-list-action"
                      onClick={(e) => startEditingCourseExamDate(course, e)}
                    >
                      {course.exam_date ? `Prova: ${formatExamDate(course.exam_date)}` : 'Definir data da prova'}
                    </button>
                  )}
                </li>
              ))}
              <li onClick={selectFreeQuestions} className={`admin-nav-list-alt ${selectedMock?.id === null ? 'selected' : ''}`}>
                Questões Livres (sem simulado)
              </li>
            </ul>
          </div>

          <div className="admin-card">
            <h3>Nova matéria</h3>
            <div className="admin-inline-form">
              <input
                type="text"
                placeholder="Nome da matéria"
                value={newSubject.name}
                onChange={(e) => setNewSubject({ ...newSubject, name: e.target.value })}
              />
              <button className="admin-btn-secondary" onClick={handleCreateSubject}>Criar</button>
            </div>
            {subjects.length > 0 && (
              <div className="admin-chip-list">
                {subjects.map((subject) => (
                  <span key={subject.id} className="admin-chip">
                    {subject.name}
                    {subject.canonical_subject_id && (
                      <small className="admin-chip-hint"> (= {subject.canonical_subject_name})</small>
                    )}
                  </span>
                ))}
              </div>
            )}
          </div>

          <div className={`admin-card admin-collapsible-card${materialsOpen ? ' open' : ''}`}>
            <button type="button" className="admin-collapsible-header" onClick={() => setMaterialsOpen((open) => !open)}>
              <span>Materiais <small>(opcional)</small></span>
              <span className="admin-collapsible-count">{materials.length}</span>
              <span className="admin-collapsible-caret">{materialsOpen ? '−' : '+'}</span>
            </button>
            {materialsOpen && (
              <div className="admin-collapsible-body">
                <input
                  type="text"
                  placeholder="Nome do material"
                  value={newMaterial.nome}
                  onChange={(e) => setNewMaterial({ ...newMaterial, nome: e.target.value })}
                />
                <input
                  type="text"
                  placeholder="URL do arquivo"
                  value={newMaterial.url}
                  onChange={(e) => setNewMaterial({ ...newMaterial, url: e.target.value })}
                />
                <label className="admin-checkbox-label">
                  <input
                    type="checkbox"
                    checked={newMaterial.is_free}
                    onChange={(e) => setNewMaterial({ ...newMaterial, is_free: e.target.checked })}
                  />
                  Grátis (liberado sem plano pago)
                </label>
                <label className="admin-checkbox-label">
                  <input
                    type="checkbox"
                    checked={newMaterial.is_new}
                    onChange={(e) => setNewMaterial({ ...newMaterial, is_new: e.target.checked })}
                  />
                  Marcar como "Novidade"
                </label>
                <button className="admin-btn-secondary" onClick={handleCreateMaterial}>Criar Material</button>
                {materials.length > 0 && (
                  <ul className="admin-simple-list">
                    {materials.map((material) => (
                      <li key={material.id}>{material.nome}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        </aside>

        <main className="admin-main">
          <details className="admin-topic-library admin-card" open={!selectedCourse && !selectedMock}>
            <summary>Catálogo de tópicos<span>Cadastre conteúdos por matéria e reutilize nos concursos.</span></summary>
            <TopicCatalog apiUrl={apiUrl} subjects={subjects} />
          </details>
          {!selectedCourse && !selectedMock && (
            <div className="admin-empty-state">
              <p>Selecione um concurso ao lado para gerenciar simulados, matérias e questões, ou escolha "Questões Livres".</p>
            </div>
          )}

          {selectedCourse && (
            <>
              <div className="admin-main-header">
                <h2>{selectedCourse.name}</h2>
                <button type="button" className="admin-btn-secondary" onClick={handleSyncCourseQuestions}>
                  Sincronizar Questões
                </button>
              </div>

              <div className="admin-detail-grid">
                <div className="admin-card">
                  <h3>Simulados</h3>
                  <input
                    type="text"
                    placeholder="Nome do Simulado"
                    value={newMock.name}
                    onChange={(e) => setNewMock({ ...newMock, name: e.target.value, course_id: selectedCourse.id })}
                  />
                  <textarea
                    placeholder="Descrição"
                    value={newMock.description}
                    onChange={(e) => setNewMock({ ...newMock, description: e.target.value })}
                  />
                  <input
                    type="number"
                    placeholder="Número de Questões"
                    value={newMock.numero_questoes}
                    onChange={(e) => setNewMock({ ...newMock, numero_questoes: parseInt(e.target.value) })}
                  />
                  <label className="admin-checkbox-label">
                    <input
                      type="checkbox"
                      checked={newMock.is_free}
                      onChange={(e) => setNewMock({ ...newMock, is_free: e.target.checked })}
                    />
                    Grátis (liberado sem plano pago)
                  </label>
                  <label className="admin-checkbox-label">
                    <input
                      type="checkbox"
                      checked={newMock.is_enabled}
                      onChange={(e) => setNewMock({ ...newMock, is_enabled: e.target.checked })}
                    />
                    Habilitado (visível para os usuários)
                  </label>
                  <button className="admin-btn-primary" onClick={handleCreateMock}>Criar Simulado</button>

                  {mocks.length > 0 && (
                    <ul className="admin-nav-list admin-nav-list-compact">
                      {mocks.map(mock => (
                        <li key={mock.id} className={selectedMock?.id === mock.id ? 'selected' : ''}>
                          <span onClick={() => selectMock(mock)}>{mock.name}</span>
                          <label className="admin-checkbox-label admin-mock-enabled-toggle" onClick={(e) => e.stopPropagation()}>
                            <input
                              type="checkbox"
                              checked={!!mock.is_enabled}
                              onChange={(e) => handleToggleMockEnabled(mock, e.target.checked)}
                            />
                            Habilitado
                          </label>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <PhysicalExerciseManager key={selectedCourse.id} apiUrl={apiUrl} courseId={selectedCourse.id} />

                <div className="admin-card">
                  <h3>Matérias vinculadas</h3>
                  <div className="admin-inline-form">
                    <select
                      value={newCourseSubjectId}
                      onChange={(e) => handleSelectNewCourseSubject(e.target.value)}
                    >
                      <option value="">Selecione a matéria</option>
                      {subjects
                        .filter((subject) => !courseSubjects.some((cs) => String(cs.id) === String(subject.id)))
                        .map((subject) => (
                          <option key={subject.id} value={subject.id}>{subject.name}</option>
                        ))}
                    </select>
                    <button className="admin-btn-secondary" onClick={handleLinkCourseSubject}>Vincular</button>
                  </div>
                  {newCourseSubjectId && catalogTopicNames.length > 0 && (
                    <div className="admin-catalog-topics">
                      <span>Assuntos já cadastrados nessa matéria em outros concursos — marque os que quer reaproveitar aqui:</span>
                      <div className="question-course-checklist-grid">
                        {catalogTopicNames.map((topicName) => (
                          <label key={topicName}>
                            <input
                              type="checkbox"
                              checked={selectedCatalogTopics.includes(topicName)}
                              onChange={() => toggleCatalogTopic(topicName)}
                            />
                            {topicName}
                          </label>
                        ))}
                      </div>
                    </div>
                  )}
                  {courseSubjects.length > 0 ? (
                    <ul className="admin-nav-list admin-nav-list-compact">
                      {courseSubjects.map((courseSubject) => (
                        <li
                          key={courseSubject.course_subject_id}
                          onClick={() => selectCourseSubject(courseSubject)}
                          className={selectedCourseSubject?.course_subject_id === courseSubject.course_subject_id ? 'selected' : ''}
                        >
                          <span>{courseSubject.name}</span>
                          <button
                            type="button"
                            className="admin-unlink-btn"
                            onClick={(e) => { e.stopPropagation(); handleUnlinkCourseSubject(courseSubject.course_subject_id); }}
                          >
                            Remover
                          </button>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="admin-empty-hint">Nenhuma matéria vinculada ainda.</p>
                  )}
                </div>
              </div>

              {selectedCourseSubject && <TopicCatalog key={selectedCourseSubject.course_subject_id} apiUrl={apiUrl} subjects={subjects} courseSubject={selectedCourseSubject} />}

              <div className={`admin-card admin-collapsible-card admin-subsection${courseMaterialsOpen ? ' open' : ''}`}>
                <button type="button" className="admin-collapsible-header" onClick={() => setCourseMaterialsOpen((open) => !open)}>
                  <span>Materiais de {selectedCourse.name} <small>(opcional)</small></span>
                  <span className="admin-collapsible-count">{courseMaterials.length}</span>
                  <span className="admin-collapsible-caret">{courseMaterialsOpen ? '−' : '+'}</span>
                </button>
                {courseMaterialsOpen && (
                  <div className="admin-collapsible-body">
                    <div className="admin-inline-form">
                      <select
                        value={newCourseMaterialId}
                        onChange={(e) => setNewCourseMaterialId(e.target.value)}
                      >
                        <option value="">Selecione o material</option>
                        {materials
                          .filter((material) => !courseMaterials.some((cm) => String(cm.id) === String(material.id)))
                          .map((material) => (
                            <option key={material.id} value={material.id}>{material.nome}</option>
                          ))}
                      </select>
                      <button className="admin-btn-secondary" onClick={handleLinkCourseMaterial}>Vincular</button>
                    </div>
                    {courseMaterials.length > 0 ? (
                      <ul className="admin-simple-list">
                        {courseMaterials.map((courseMaterial) => (
                          <li key={courseMaterial.course_material_id}>
                            {courseMaterial.nome}
                            <button className="admin-unlink-btn" onClick={() => handleUnlinkCourseMaterial(courseMaterial.course_material_id)}>
                              Remover
                            </button>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="admin-empty-hint">Nenhum material vinculado ainda.</p>
                    )}
                  </div>
                )}
              </div>
            </>
          )}

          {selectedMock && (
            <div className="admin-question-section">
              <div className="admin-card">
                <h3>
                  {editingQuestionId
                    ? `Editar Questão — ${selectedMock.name}`
                    : `Cadastrar Questão — ${selectedMock.name}`}
                </h3>
                <textarea
                  placeholder="Enunciado da Questão"
                  value={newQuestion.title}
                  onChange={(e) => setNewQuestion({ ...newQuestion, title: e.target.value, mock_id: selectedMock.id })}
                />
                <select
                  value={newQuestion.subject_id}
                  onChange={(e) => setNewQuestion({ ...newQuestion, subject_id: e.target.value, topic_id: '', catalog_topic_id: '' })}
                >
                  <option value="">Selecione a Matéria</option>
                  {subjects.map(subject => (
                    <option key={subject.id} value={subject.id}>{subject.name}</option>
                  ))}
                </select>
                <select
                  value={newQuestion.catalog_topic_id}
                  onChange={(e) => setNewQuestion({ ...newQuestion, topic_id: '', catalog_topic_id: e.target.value })}
                >
                  <option value="">Selecione o Assunto (opcional)</option>
                  {questionTopics.map(topic => (
                    <option key={topic.id} value={topic.id}>{topic.name}</option>
                  ))}
                </select>
                <input
                  type="number"
                  placeholder="Ano"
                  value={newQuestion.year}
                  onChange={(e) => setNewQuestion({ ...newQuestion, year: e.target.value })}
                />
                <input
                  type="text"
                  placeholder="Órgão (banca/instituição do concurso)"
                  value={newQuestion.institution}
                  onChange={(e) => setNewQuestion({ ...newQuestion, institution: e.target.value })}
                />
                {editingQuestionId && newQuestion.existingImageUrl && !newQuestion.image && (
                  <div className="admin-question-image-preview">
                    <img src={newQuestion.existingImageUrl} alt="Imagem atual da questão" />
                    <span>Imagem atual — escolha um novo arquivo abaixo para substituí-la.</span>
                  </div>
                )}
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setNewQuestion({ ...newQuestion, image: e.target.files[0] })}
                />
                <input
                  type="text"
                  placeholder="Alternativa A"
                  value={newQuestion.choice_a}
                  onChange={(e) => setNewQuestion({ ...newQuestion, choice_a: e.target.value })}
                />
                <input
                  type="text"
                  placeholder="Alternativa B"
                  value={newQuestion.choice_b}
                  onChange={(e) => setNewQuestion({ ...newQuestion, choice_b: e.target.value })}
                />
                <input
                  type="text"
                  placeholder="Alternativa C"
                  value={newQuestion.choice_c}
                  onChange={(e) => setNewQuestion({ ...newQuestion, choice_c: e.target.value })}
                />
                <input
                  type="text"
                  placeholder="Alternativa D"
                  value={newQuestion.choice_d}
                  onChange={(e) => setNewQuestion({ ...newQuestion, choice_d: e.target.value })}
                />
                <input
                  type="text"
                  placeholder="Alternativa E"
                  value={newQuestion.choice_e}
                  onChange={(e) => setNewQuestion({ ...newQuestion, choice_e: e.target.value })}
                />
                <select
                  value={newQuestion.correct}
                  onChange={(e) => setNewQuestion({ ...newQuestion, correct: e.target.value })}
                >
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                  <option value="E">E</option>
                </select>
                <textarea
                  placeholder="Resposta Correta (explicação)"
                  value={newQuestion.answer}
                  onChange={(e) => setNewQuestion({ ...newQuestion, answer: e.target.value })}
                />
                <textarea
                  placeholder="Explicação Detalhada"
                  value={newQuestion.explication}
                  onChange={(e) => setNewQuestion({ ...newQuestion, explication: e.target.value })}
                />
                <div className="admin-question-form-actions">
                  {editingQuestionId ? (
                    <>
                      <button className="admin-btn-primary" onClick={handleUpdateQuestion}>Salvar Alterações</button>
                      <button className="admin-btn-secondary" onClick={handleCancelEditQuestion}>Cancelar</button>
                    </>
                  ) : (
                    <button className="admin-btn-primary" onClick={handleCreateQuestion}>Criar Questão</button>
                  )}
                </div>
              </div>

              <div className="admin-card">
                {selectedMock?.id === null ? (
                  <>
                    <h3>Questões livres cadastradas ({freeQuestionsTotal})</h3>
                    <div className="admin-inline-form">
                      <select
                        value={freeQuestionsSubjectFilter}
                        onChange={(e) => {
                          setFreeQuestionsSubjectFilter(e.target.value);
                          setFreeQuestionsTopicFilter('');
                          setFreeQuestionsPage(1);
                        }}
                      >
                        <option value="">Todas as matérias</option>
                        {subjects.map((subject) => (
                          <option key={subject.id} value={subject.id}>{subject.name}</option>
                        ))}
                      </select>
                      <select
                        value={freeQuestionsTopicFilter}
                        onChange={(e) => {
                          setFreeQuestionsTopicFilter(e.target.value);
                          setFreeQuestionsPage(1);
                        }}
                        disabled={!freeQuestionsSubjectFilter || freeQuestionsTopicOptions.length === 0}
                      >
                        <option value="">Todos os assuntos</option>
                        {freeQuestionsTopicOptions.map((topic) => (
                          <option key={topic.id} value={topic.id}>{topic.name}</option>
                        ))}
                      </select>
                    </div>
                    {questions.length > 0 ? (
                      <ul className="admin-question-list">
                        {questions.map(question => (
                          <li key={question.id} className={editingQuestionId === question.id ? 'editing' : ''}>
                            <div className="admin-question-list-main">
                              <p className="admin-question-list-title">{question.title}</p>
                              <div className="admin-question-list-badges">
                                {question.subject_name && (
                                  <span className="admin-badge admin-badge-subject">{question.subject_name}</span>
                                )}
                                {question.topic_name && (
                                  <span className="admin-badge admin-badge-topic">{question.topic_name}</span>
                                )}
                                {question.course_ids
                                  ? String(question.course_ids).split(',').map(Number).map((courseId) => {
                                      const course = courses.find((c) => c.id === courseId);
                                      return course ? (
                                        <span key={courseId} className="admin-badge admin-badge-course">{course.name}</span>
                                      ) : null;
                                    })
                                  : null}
                              </div>
                            </div>
                            <div className="admin-question-list-actions">
                              <button type="button" className="admin-btn-small" onClick={() => handleEditQuestion(question)}>Editar</button>
                              <button type="button" className="admin-btn-small admin-btn-danger" onClick={() => handleDeleteQuestion(question.id)}>Excluir</button>
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="admin-empty-hint">Nenhuma questão cadastrada ainda.</p>
                    )}
                    {freeQuestionsTotal > FREE_QUESTIONS_PAGE_SIZE && (
                      <div className="crm-pagination">
                        <button onClick={() => setFreeQuestionsPage(1)} disabled={freeQuestionsPage <= 1}>«</button>
                        <button onClick={() => setFreeQuestionsPage((p) => Math.max(1, p - 1))} disabled={freeQuestionsPage <= 1}>‹</button>
                        <span>
                          Página {freeQuestionsPage} de {Math.max(1, Math.ceil(freeQuestionsTotal / FREE_QUESTIONS_PAGE_SIZE))}
                          {' '}({freeQuestionsTotal} questões)
                        </span>
                        <button
                          onClick={() => setFreeQuestionsPage((p) => Math.min(Math.ceil(freeQuestionsTotal / FREE_QUESTIONS_PAGE_SIZE), p + 1))}
                          disabled={freeQuestionsPage >= Math.ceil(freeQuestionsTotal / FREE_QUESTIONS_PAGE_SIZE)}
                        >›</button>
                        <button
                          onClick={() => setFreeQuestionsPage(Math.ceil(freeQuestionsTotal / FREE_QUESTIONS_PAGE_SIZE))}
                          disabled={freeQuestionsPage >= Math.ceil(freeQuestionsTotal / FREE_QUESTIONS_PAGE_SIZE)}
                        >»</button>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <h3>Questões cadastradas ({questions.length})</h3>
                    {(() => {
                      const topicFilterOptions = Array.from(
                        new Map(
                          questions
                            .filter((q) => (q.catalog_topic_id || q.topic_id) && q.topic_name)
                            .map((q) => [q.catalog_topic_id || q.topic_id, q.topic_name])
                        ).entries()
                      ).sort((a, b) => a[1].localeCompare(b[1]));
                      return topicFilterOptions.length > 0 ? (
                        <div className="admin-inline-form">
                          <select
                            value={questionTopicFilter}
                            onChange={(e) => setQuestionTopicFilter(e.target.value)}
                          >
                            <option value="">Todos os assuntos</option>
                            {topicFilterOptions.map(([topicId, topicName]) => (
                              <option key={topicId} value={topicId}>{topicName}</option>
                            ))}
                          </select>
                        </div>
                      ) : null;
                    })()}
                    {(() => {
                      const visibleQuestions = questionTopicFilter
                        ? questions.filter((q) => String(q.catalog_topic_id || q.topic_id) === String(questionTopicFilter))
                        : questions;
                      return visibleQuestions.length > 0 ? (
                      <ul className="admin-question-list">
                        {visibleQuestions.map(question => (
                          <li key={question.id} className={editingQuestionId === question.id ? 'editing' : ''}>
                            <div className="admin-question-list-main">
                              <p className="admin-question-list-title">{question.title}</p>
                              <div className="admin-question-list-badges">
                                {question.subject_name && (
                                  <span className="admin-badge admin-badge-subject">{question.subject_name}</span>
                                )}
                                {question.topic_name && (
                                  <span className="admin-badge admin-badge-topic">{question.topic_name}</span>
                                )}
                                {question.year && (
                                  <span className="admin-badge admin-badge-year">{question.year}</span>
                                )}
                                {question.institution && (
                                  <span className="admin-badge admin-badge-institution">{question.institution}</span>
                                )}
                                {question.course_ids
                                  ? String(question.course_ids).split(',').map(Number).map((courseId) => {
                                      const course = courses.find((c) => c.id === courseId);
                                      return course ? (
                                        <span key={courseId} className="admin-badge admin-badge-course">{course.name}</span>
                                      ) : null;
                                    })
                                  : <span className="admin-badge admin-badge-empty">Sem concurso vinculado</span>}
                              </div>
                            </div>
                            <div className="admin-question-list-actions">
                              <button type="button" className="admin-btn-small" onClick={() => handleEditQuestion(question)}>Editar</button>
                              <button type="button" className="admin-btn-small admin-btn-danger" onClick={() => handleDeleteQuestion(question.id)}>Excluir</button>
                            </div>
                          </li>
                        ))}
                      </ul>
                      ) : (
                        <p className="admin-empty-hint">Nenhuma questão cadastrada ainda.</p>
                      );
                    })()}
                  </>
                )}
              </div>
            </div>
          )}
        </main>
      </div>
      )}
    </div>
  );
};

export default AdminPage;
